import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import { PageUploadDropzone } from './PageUploadDropzone';
import { TenantProfileUploadProvider } from './TenantProfileUploadProvider';
import { UploadProgressTray } from './UploadProgressTray';

/**
 * Shared layout for the Organization Profile and Document Hub pages. Hosts the
 * upload engine once (so both pages share its state), turns the whole page into
 * a drop target, and renders the floating upload tray. Drop a file anywhere —
 * the backend classifies it and auto-extracts on a valid verdict; no modal, no
 * Extract click. The document review page sits outside this layout, so it is
 * deliberately not a drop target.
 */
export const TenantProfileUploadLayout: FC = observer(() => (
  <TenantProfileUploadProvider>
    <PageUploadDropzone>
      <Outlet />
    </PageUploadDropzone>
    <UploadProgressTray />
  </TenantProfileUploadProvider>
));
